<section class="event-manager">
    <form [formGroup]="createEventForm" (ngSubmit)="onCreateEventFormSubmit()" id="createEvent-form" novalidate>
        <div class="event-manager__container-img">
            <img class="event-manager__img" [src]="imagePath" alt="event1">
            <div class="event-manager__img-text-top-left">
                <div (click)="cropAndCompressImageDialog()" class="d-flex flex-row">
                    <mat-icon class="edit-icon">brush</mat-icon>
                </div>
            </div>
            <div class="event-manager__img-text-top-right">
                <a routerLink="/promoter/events" [queryParams]="navigateToTab ? { activeIndex: navigateToTab } : {}">
                    <mat-icon>clear</mat-icon>
                </a>
            </div>
            <div class="event-manager__img-text-bottom-right">
                <mat-spinner *ngIf="loadingPage" class="sign-in-spinner"></mat-spinner>
                <button type="submit" class="button"
                    [disabled]="!createEventForm.valid || venueId=='' || eventtypesIds.length == 0">{{ 'PUBLISH' |
                    translate }}</button>
                <button type="button" class="button"
                    [disabled]="!createEventForm.valid || venueId=='' || eventtypesIds.length == 0"
                    (click)="AddEventAsDraft()">{{ 'SAVE_DRAFT' | translate }}</button>
                <button type="button" class="button" routerLink="/promoter/events" [queryParams]="navigateToTab ? { activeIndex: navigateToTab } : {}">{{ 'CANCEL' | translate }}</button>
            </div>
        </div>
        <mat-accordion>
            <mat-expansion-panel hideToggle expanded>
                <div class="create-event ps-4 pt-4 pe-4">
                    <div class="d-flex flex-row gap-5">
                        <div class="w-100">
                            <div class="d-flex flex-row justify-content-between label-info">
                                <label for="eventname1">{{ 'EVENTS.EVENT_NAME' | translate }} *</label>
                                <div *ngIf="eventFormControls.eventName?.invalid && (eventFormControls.eventName?.dirty || eventFormControls.eventName?.touched)"
                                    class="alert alert-danger">
                                    <div class="d-flex flex-row alert-danger-content">
                                        <div class="alert-danger-info"
                                            *ngIf="eventFormControls.eventName?.errors?.['required']"
                                            matTooltipClass="tooltip-danger"
                                            matTooltip="{{ 'INFO.ENAME_REQUIRED' | translate }}">
                                            <div>?</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <textarea #MyEventName type="text" id="eventname1" class="custom-scroll-bar" [value]=""
                                formControlName="eventName" placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
                                (input)="eventname = MyEventName.value" [maxlength]="maxChars"></textarea>
                            <p class="text-end">{{eventname.length}}/{{maxChars}}<span class="char-count">C</span></p>
                        </div>
                        <div class="w-100">
                            <div class="d-flex flex-row justify-content-between label-info">
                                <label for="description1">{{ 'EVENTS.EVENT_DESCRIPTION' | translate }} *</label>
                                <div *ngIf="eventFormControls.eventDescription?.invalid && (eventFormControls.eventDescription?.dirty || eventFormControls.eventDescription?.touched)"
                                    class="alert alert-danger">
                                    <div class="d-flex flex-row alert-danger-content">
                                        <div class="alert-danger-info"
                                            *ngIf="eventFormControls.eventDescription?.errors?.['required']"
                                            matTooltipClass="tooltip-danger"
                                            matTooltip="{{ 'INFO.EDESCRIPTION_REQUIRED' | translate }}">
                                            <div>?</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <textarea #MyEventDescription type="text" id="description1" class="custom-scroll-bar"
                                [value]="" formControlName="eventDescription"
                                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"
                                (input)="description1 = MyEventDescription.value"
                                [maxlength]="description1maxChars"></textarea>
                            <p class="text-end">{{description1.length}}/{{description1maxChars}}<span
                                    class="char-count">C</span></p>
                        </div>
                        <div class="d-flex flex-column w-100" style="width:1000px !important;">

                            <div class="d-flex flex-row gap-3 mb-3" style="width:240px;">
                                <div class="w-100">
                                    <div class="d-flex flex-row justify-content-between label-info">
                                        <label for="date">{{ 'EVENTS.DATE' | translate }} *</label>
                                        <div *ngIf="eventFormControls.eventDate.invalid && (eventFormControls.eventDate?.dirty || eventFormControls.eventDate?.touched)"
                                            class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    *ngIf="eventFormControls.eventDate?.errors?.['required']"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{ 'INFO.DATE_REQUIRED' | translate }}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p-calendar dateTimeMask formControlName="eventDate" [minDate]="minDate" [showIcon]="true"
                                        placeholder="mm/dd/yyyy"></p-calendar>

                                </div>
                                <!-- <p-calendar formControlName="rangeDates" inputId="range" selectionMode="range" [showTime]="true" hourFormat="24" [showIcon]="true"></p-calendar> -->
                                <div class="w-100">
                                    <div class="d-flex flex-row justify-content-between label-info">
                                        <label for="time">{{ 'EVENTS.TIME' | translate }} *</label>
                                        <div *ngIf="(eventFormControls.startTime.invalid && (eventFormControls.startTime.dirty || eventFormControls.startTime?.touched))"
                                            class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    *ngIf="eventFormControls.startTime?.errors?.['required'] && eventFormControls.endTime?.errors?.['required']"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{ 'INFO.TIME_REQUIRED' | translate }}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="errorModel!=null && errorModel['pastdatetime']!=null" class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{errorModel['pastdatetime']|translate}}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="(eventFormControls.endTime.invalid && (eventFormControls.endTime.dirty || eventFormControls.endTime?.touched))"
                                            class="alert alert-danger">
                                            <div class="d-flex flex-row alert-danger-content">
                                                <div class="alert-danger-info"
                                                    *ngIf="eventFormControls.endTime?.errors?.['required']"
                                                    matTooltipClass="tooltip-danger"
                                                    matTooltip="{{ 'INFO.TIME_REQUIRED' | translate }}">
                                                    <div>?</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p-calendar dateTimeMask formControlName="startTime" [timeOnly]="true" [showTime]="true"
                                        hourFormat="24" icon="pi pi-clock" [showIcon]="true" placeholder="hh:mm">
                                    </p-calendar>
                                    <p-calendar dateTimeMask formControlName="endTime" [timeOnly]="true" [showTime]="true"
                                        hourFormat="24" icon="pi pi-clock" [showIcon]="true" placeholder="hh:mm">
                                    </p-calendar>
                                </div>
                            </div>

                            <div>
                                <app-eventtypes-multi-select id="eventtype" [title]="('EVENTS.EVENT_TYPE' | translate)"
                                    [list]="eventTypeList" [operation]="operations"
                                    (shareCheckedList)="shareCheckedList($event)">
                                </app-eventtypes-multi-select>
                            </div>

                        </div>
                        <div class="d-flex flex-column w-100">
                            <div class="mb-3">
                                <app-single-select-venue (shareSelectedItem)="selectedVenue($event)"
                                    [operation]="this.operations"></app-single-select-venue>
                            </div>
                            <div>
                                <label class="label-info" for="capacity">{{ 'EVENTS.CAPACITY' | translate }}</label>
                                <div
                                    class="create-event__capacity d-flex flex-row justify-content-between align-items-center">
                                    <div class="d-flex flex-row align-items-center">
                                        <mat-icon>person</mat-icon>
                                        <p class="ps-1">{{capacity}}</p>
                                    </div>
                                    <!-- <div class="d-flex flex-row align-items-center" (click)="openCapacity()"
                                        style="text-align: right; cursor: pointer;">
                                        <mat-icon>event_note</mat-icon>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </form>
</section>
